import React, { useEffect, useState } from "react";
import { toast } from "sonner";

import api from "../../lib/api";
import AdminLayout from "../../components/admin/AdminLayout";
import JobResponsesTable from "../../components/admin/JobResponsesTable";

const isActiveValue = (r) =>
  r.is_active === true || r.is_active === 1 || r.is_active === "1";

const JobPostResponse = () => {
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchResponses = async () => {
      try {
        // Auth token is attached automatically by the api interceptor.
        const { data } = await api.get("/job-responses");
        const list = Array.isArray(data)
          ? data
          : data?.data || data?.responses || [];
        setResponses(list);
      } catch (error) {
        toast.error(
          error.response?.data?.message || "Failed to load job responses"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchResponses();
  }, []);

  // Toggle is_active via the status API. Update optimistically, roll back on error.
  const handleToggleStatus = async (res) => {
    const original = res.is_active;
    const newStatus = isActiveValue(res) ? 0 : 1;

    setResponses((prev) =>
      prev.map((r) => (r.id === res.id ? { ...r, is_active: newStatus } : r))
    );

    try {
      await api.post(`/job-responses/${res.id}/status`, {
        is_active: newStatus,
      });
      toast.success("Status updated");
    } catch (error) {
      // Revert on failure.
      setResponses((prev) =>
        prev.map((r) => (r.id === res.id ? { ...r, is_active: original } : r))
      );
      toast.error(error.response?.data?.message || "Failed to update status");
    }
  };

  return (
    <AdminLayout title="Applicants">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Applicants</h2>
        <p className="mt-1 text-sm text-gray-600">
          Manage candidate applications.
        </p>
      </div>

      <JobResponsesTable
        responses={responses}
        loading={loading}
        onToggleStatus={handleToggleStatus}
      />
    </AdminLayout>
  );
};

export default JobPostResponse;
